import { Flex } from 'modules/ui';
import styled from 'styled-components';

export const PageLayout = styled(Flex)`
  min-height: 100vh;
  align-items: center;
    background-color: ${({theme}) => theme.colors.primaryW};
  & > *:not(.full-width-container, footer) {
    background-color: transparent;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    max-width: 76rem;
    width: 100%;
    flex: 0;

    &:not(:where(header, footer)) {
      flex: 1;
    }
  }

  footer > div:not(.full-width-container) {
    max-width: 76rem;
  }
`;

// TODO - Mozemo li ovo premjestiti na neko bolje mjesto?
export const FormMaxWidth = '24.25rem';
